import { render } from "./RadialBarChart.vue?vue&type=template&id=59a38da7&scoped=true"
import script from "./RadialBarChart.vue?vue&type=script&lang=js"
export * from "./RadialBarChart.vue?vue&type=script&lang=js"

import "./RadialBarChart.vue?vue&type=style&index=0&id=59a38da7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a38da7"]])

export default __exports__